export default __webpack_public_path__ + "media/images/features/yado/next_sp-a1d30bc5dcd615b5e5c2128f3ecd62db.png";